import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../lib/i18next";
import { TEMPLATES_SAVE_TRANSPARENCY_GAP_DESCRIPTION } from "../../../i18n/keysTranslations";

export const TemplateTransparencyGapAlertContent = ({ gaps = [] }) => {
  const { t } = useTranslationApp();

  return (
    <Box
      sx={{
        width: "100%",
        maxHeight: "400px",
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        {t(TEMPLATES_SAVE_TRANSPARENCY_GAP_DESCRIPTION)}
      </Typography>
      <Box
        component="ul"
        sx={{
          m: 0,
          p: 0,
          listStyle: "none",
          textAlign: "center",
          width: "fit-content",
          maxWidth: "100%",
        }}
      >
        {gaps.map((gap) => (
          <Typography
            key={`${gap.slide || ""}-${gap.artboardID}`}
            component="li"
            variant="body2"
            sx={{ fontWeight: 600 }}
          >
            {gap.slide ? `${gap.slide} · ${gap.format}` : gap.format}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
